module.exports = __webpack_public_path__ + "svg/user_icon.061ee3b0fe8f990ba12e6ce65b80ce01.svg";